import { NgModule } from '@angular/core';
import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { SharedModule } from '@shared';

import { EmployeesRestrictionsModalModule, OptimizationInterceptor } from 'planner-shared';

import { PlannerRoutingModule } from './planner-routing.module';
import { PlannerComponent } from './planner.component';
import { EmployeesModule } from './employee/employee.module';
import { DataUpdateModule } from './data-update/data-update.module';
import { OptimizationModule } from './optimization/optimization.module';
import { RoutePlanningModule } from './route-planning/route-planning.module';
import { CsatComponent } from './feedback/csat/csat.component';
import { CsatPrivacyComponent } from './feedback/csat/csat-privacy/csat-privacy.component';
import { RideSharingBarComponent } from './shared/ride-sharing-bar/ride-sharing-bar.component';
import { ReportComponent } from './feedback/issue-report/report.component';
import { FeedbackComponent } from './feedback/feedback.component';

@NgModule({
    declarations: [
        PlannerComponent,
        CsatComponent,
        CsatPrivacyComponent,
        RideSharingBarComponent,
        ReportComponent,
        FeedbackComponent
    ],
    imports: [
        SharedModule,
        PlannerRoutingModule,
        EmployeesModule,
        DataUpdateModule,
        OptimizationModule,
        RoutePlanningModule,
        EmployeesRestrictionsModalModule
    ],
    providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: OptimizationInterceptor,
            multi: true
        }
    ]
})
export class PlannerModule {}
